import { render, staticRenderFns } from "./ModalEditSpendType.vue?vue&type=template&id=631908ae&scoped=true"
import script from "./ModalEditSpendType.vue?vue&type=script&lang=js"
export * from "./ModalEditSpendType.vue?vue&type=script&lang=js"
import style0 from "./ModalEditSpendType.vue?vue&type=style&index=0&id=631908ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631908ae",
  null
  
)

export default component.exports